<template>
 <v-dialog
      @click:outside='clickoutside'
      v-model="messageDialog"
      max-width='1000'>

      
      <v-card  v-if='currentMessage'>
          <v-toolbar  dense>
      <v-toolbar-title v-if='currentMessage.messageType === "non-system"'>Message to: {{currentMessage.message_to.email}}</v-toolbar-title>

      <v-spacer></v-spacer>

    
    </v-toolbar>
        
        <v-card-title class="headline">{{currentMessage.title}}</v-card-title>

        <v-card-text>
               <v-timeline dense>
              <v-timeline-item
                :icon="computeIcon(n.message_to.email)"
                v-for="(n,index) in currentMessage.messageThread"
                :key="index"
              >
                <span slot="opposite">From : {{n.message_from.email}}</span>
                <v-card :class="computeColor(n.message_to.email)">
                
                  <v-card-text :class="computeTextColor(n.message_to.email)">
                   <v-icon class="float-left">chat</v-icon>
                  <span class="float-left" >{{n.message_from.email}}</span>
                  <span class="float-right" >{{n.createdAt}}</span>
                  <br/>
                  <div class='mt-5'></div>
                  {{n.messageBody}}
                  </v-card-text>
                </v-card>
              </v-timeline-item>
              </v-timeline>
              <br />
                <v-textarea
                class='pt-5'
                v-model='replyMessage'
          outlined
          name="input-7-4"
          label="Reply Message Here"
        ></v-textarea>
        <fileDialog @uploadcomplete="fetchFileList" :filesList='filesList'/>
        </v-card-text>

        <v-card-actions>
          
          <v-spacer></v-spacer>
        <v-btn
            color="green darken-1"
            text
            :disabled='replyMessage === null || replyMessage === ""'
            @click="sendReply">
            Reply
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="clickoutside">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-banner v-else single-line >
    <v-icon
      slot="icon"
      color="warning"
      size="36"
    >
      warning
    </v-icon>
    Unable to retrive any data, message no longer exist
    <template v-slot:actions>
      <v-btn
      @click='removeTask'
        color="warning"
      >
        Remove Task
      </v-btn>
    </template>
  </v-banner>


    </v-dialog>
</template>

<script>
import { postReq,replyMessage} from '../../helper/firestore'
import { mapFields } from 'vuex-map-fields';
import fileDialog from '../../components/myTasks/newUsersModal/files'

export default {
  props : {
    taskid : String,
    messageId : String,
    inputMessage : Object
  },
  components : {
    fileDialog
  },
  data() {
    return {
      replyMessage : null,
      currentMessage : null,
      messageDialog : true,
      message : null,
      filesList : null,
    }
  },
  methods : {
          fetchFileList(){
          postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/patients/getPatientsFiles',{uid:this.inputMessage.message_from.uid},result=>{
          this.filesList = result.data
        })
      },
    removeTask(){
          postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/deleteTask',{taskid :this.taskid},()=>{
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = "Task removed"
        })

    },
    clickoutside(){    
      this.$emit('clickoutside')
    },
    computeSender(currentMessage){
      if(currentMessage.message_from.email === this.user.email){
        return currentMessage.message_to;
      }
      else {
        return currentMessage.message_from;
      }
    },
            sendReply(){
       var replyMessageThread = {
         message_to:{
           email:this.computeSender(this.currentMessage).email,
           uid:this.computeSender(this.currentMessage).uid
           },
           message_from:{
           email:this.user.email,
           uid:this.user.uid
           },
           read:false,
           createdAt: null,
           messageBody:this.replyMessage,
           messageID:null
           }
       replyMessage({
         messageID : this.currentMessage.messageID,
         messageBody : replyMessageThread
       },() => {
         this.replyMessage = null
      })
     this.clickoutside()
    },
 computeIcon(to_email){
      let iconClass = to_email === this.user.email ? "supervisor_account" : "person"
       return iconClass
    },
    computeColor(to_email){
      let cardClassName = to_email === this.user.email ? "elevation-2" : "blue elevation-2"
       return cardClassName
    },
    computeTextColor(to_email){
       let cardClassName = to_email === this.user.email ? "" : "white--text"
       return cardClassName
    },
  },
  mounted(){
    if(this.inputMessage === null || this.inputMessage === undefined){
          postReq(process.env.VUE_APP_ROOT_API_URL +'api/messages/getmessagesbyMessageID',{messageID:this.messageId},result=>{
      this.currentMessage = result.data[0];
        })
    }
    else {
      
    this.currentMessage = this.inputMessage
    this.fetchFileList();
    }

  },
            computed : {
    ...mapFields([
      'myMessage',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
    },
}
</script>

<style>

</style>